import { Subject } from 'rxjs';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-confirmation-pop-up',
    templateUrl: './confirmation-pop-up.component.html',
    styleUrls: ['./confirmation-pop-up.component.scss'],
    standalone: false
})
export class ConfirmationPopUpComponent implements OnInit {
	@Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	private _visible: boolean = false;
	@Input()
	public set visible(value: boolean) {
		this._visible = value;

		this.visibleChange.emit(this._visible);
	}
	public get visible(): boolean {
		return this._visible;
	}

	@Input() public showTitle: boolean = true;
	@Input() public title: string = "Are you sure?";
	@Input() public description: string;

	@Input() public width: string | number | Function = 400;
	@Input() public height: string | number | Function = 'auto';

	@Output() public onHidden: EventEmitter<any> = new EventEmitter<any>();
	@Output() public onDisposing: EventEmitter<any> = new EventEmitter<any>();

	@Input() public buttonsData: {text: string, onClick: Subject<any>}[] = [];

	constructor() { }

	ngOnInit() {
	}
}
